$(document).ready(function() {
    setTimeout(function() {
        $(".home").addClass("loaded");
    }, 600);
    
	$(".nav_trigger").click(function(e) {
		e.preventDefault();
		$("html").toggleClass("nav--on");
	});
    
    $(".sub_nav_contain").click(function(e) {
		$("html").toggleClass("sub_nav--on");
	});
    
    $(".sidebar_nav").click(function(e) {
		$("html").toggleClass("sidebar_nav--on");
	});
    
    $('a[href*="#"]')
        .not('[href="#"]')
        .not('[href*="/about#history"]')
		.not('[href*="/solar-development/our-projects#project_map"]').click(function(e) {

		e.preventDefault();
		
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');

            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top
                }, 800); 
            }
        }
    });
	
	// Cache selectors
	var lastId,
		uiMenu = $(".page_nav ul"),
		// All list items
		menuItems = uiMenu.find("a"),
		// Anchors corresponding to menu items
		scrollItems = menuItems.map(function(){
		  var item = $($(this).attr("href"));
		  if (item.length) { return item; }
		});

	// Bind to scroll
	$(window).scroll(function(){
	   // Get container scroll position
	   var fromTop = $(this).scrollTop() + 200;

	   // Get id of current scroll item
	   var cur = scrollItems.map(function(){
		 if ($(this).offset().top < fromTop)
		   return this;
	   });
	   // Get the id of the current element
	   cur = cur[cur.length-1];
	   var id = cur && cur.length ? cur[0].id : "";

	   if (lastId !== id) {
		   lastId = id;
		   // Set/remove active class
		   menuItems
			 .parent().removeClass("active")
			 .end().filter("[href='#"+id+"']").parent().addClass("active");
	   }                   
	});
    
    $('.logo_slider').slick({
		infinite: true, 
		autoplay: true,
		speed: 250,
		slidesToShow: 6,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 4,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 800,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			}
		]
	});
    
    $('.card_slider').slick({
        infinite: false, 
		autoplay: false,
		slidesToShow: 3,
		slidesToScroll: 1,
        prevArrow: '<a href="#" class="arrow_btn prev"><svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.591 5l3.47 3.47L5 9.53.47 5 5 .47l1.06 1.06L2.592 5z" fill="#387CDF"/></svg></a>',
        nextArrow: '<a href="#" class="arrow_btn next"><svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.94 5L.47 1.53 1.53.47 6.06 5 1.53 9.53.47 8.47 3.94 5z" fill="#387CDF"/></svg></a>',
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
            {
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1
				}
			}
		]
	});
    
    $('.featured_slider').slick({
        infinite: true, 
		autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1,
        prevArrow: '<a href="#" class="arrow_btn prev"><svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M2.591 5l3.47 3.47L5 9.53.47 5 5 .47l1.06 1.06L2.592 5z" fill="#387CDF"/></svg></a>',
        nextArrow: '<a href="#" class="arrow_btn next"><svg width="7" height="10" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.94 5L.47 1.53 1.53.47 6.06 5 1.53 9.53.47 8.47 3.94 5z" fill="#387CDF"/></svg></a>'
	});
    
    $('.drop_check input').focus(function() {
         $('.drop_check').addClass( 'focused' );
    });

//    $('.drop_check input').blur(function() {
//         $('.drop_check').removeClass( 'focused' );
//    });
    
    $('.drop_trigger').click(function() {
         $('.drop_check').toggleClass( 'focused' );
    });
    
    $('.drop_check').parent().siblings().focusin(function() {
         $('.drop_check').removeClass( 'focused' );
    });
});